import { CompanyLogo, HeaderLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  LogoutText,
  BigScreen,
  SmallScreenMenu,
  SmallScreen,
  Row,
  H2,
  ImageContainer,
} from "./Styles";
import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import { scroller } from "react-scroll";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import DropDownMenu from "../../common/DropDownMenu";
import TemporaryDrawer from "./Drawer";
import useViewer from "../../../hooks/useViewer";
import AuthService from "../../../services/AuthService";
import moment from "moment";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

const EXCLUDE_URL = ["create-profile"];

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid #e1e3ee",
  },
  appSpacedBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
    marginTop: 40,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default function StyledAppBar({
  NavPages,
  hideLinks,
  LandingPage,
  ArbitPages,
  cartCount,
  setShowDrawer,
  stats,
  hideIcon,
  password,
  showDrawer,
}) {
  const { userObject, globalState, setGlobalState, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { translaterOpen } = useContext(TranslaterContext);
  const location = useLocation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);
      if (response?.status) {
        enqueueSnackbar("Logout successfully", {
          variant: "success",
        });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/login?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
        // setToken("logged_out");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      // clickPrimaryBtn: () => {
      //   localStorage.removeItem("image");
      //   setToken("logged_out");
      //   hideAlert();
      // },
      clickPrimaryBtn: () => {
        viewerLogout(userObject?.viewerId, "eventViewer");
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  /**
   * @description after login inputs
   */

  const after_login_inputs = [
    {
      name: "Home",
      link: "/live#home",
    },
    {
      name: "Agenda",
      link: "#agenda",
      section: "agenda",
      hidden:
        globalState?.event?.speakerSection?.speakersRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Speakers",
      link: "#speakers",
      section: "speakers",
      hidden:
        globalState?.event?.speakerSection?.speakersRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Resources",
      link: "#resources",
      section: "resources",
      hidden:
        globalState?.event?.resourceSection?.resourcesRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Videos",
      link: "#videos",
      section: "videos",
      hidden:
        globalState?.event?.resourceSection?.resourcesRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Polling",
      link: "#polling",
      section: "polling",
      hidden: globalState?.livepage?.livePageSettings?.livePoll ? false : true,
    },
    {
      name: globalState?.livepage?.livePageSettings?.generalGuidelinesLabel
        ? globalState?.livepage?.livePageSettings?.generalGuidelinesLabel
        : "General Guidelines Tab",
      link: "#general-guidelines-tab",
      section: "#general-guidelines-tab",
      hidden: globalState?.livepage?.livePageSettings?.generalGuidelines
        ? false
        : true,
    },
    {
      name: "FAQs",
      link: "/live#faqs",
      section: "faqs",
    },
    {
      name: "Help",
      link: "#help",
    },
    {
      name: "Feedback",
      link: "/live#feedback",
      section: "feedback",
      hidden:
        globalState?.feedback?.feedbackForm &&
        Object.keys(globalState.feedback.feedbackForm).length !== 0
          ? false
          : true,
    },
  ];

  /**
   * @before login inputs
   */

  const before_login_inputs = [
    {
      name: "Home",
      link: `${location.href.split("#")[0]}#home`,
      section: "about",
    },
    {
      name: "Agenda",
      link: `#agenda`,
      section: "agenda",
      hidden:
        globalState?.speakerSection?.speakersRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Speakers",
      link: `#speakers`,
      section: "speakers",
      hidden:
        globalState?.speakerSection?.speakersRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Resources",
      link: `#resources`,
      section: "resources",
      hidden:
        globalState?.resourceSection?.resourcesRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Videos",
      link: `#videos`,
      section: "videos",
      hidden:
        globalState?.resourceSection?.resourcesRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: globalState?.livePageSettings?.generalGuidelinesLabel
        ? globalState?.livePageSettings?.generalGuidelinesLabel
        : "General Guidelines Tab",
      link: "#general-guidelines-tab",
      hidden: globalState?.livePageSettings?.generalGuidelines ? false : true,
    },
    {
      name: "FAQs",
      link: `#faqs`,
      section: "faqs",
    },
    {
      name: "Help",
      link: "#help",
    },
  ];

  return (
    <AppBar
      position="fixed"
      style={{
        boxShadow: "5px 5px 8px #00000011",
        backgroundColor: globalState?.theme?.themeHeader?.bannerBackgroundColor
          ? globalState?.theme?.themeHeader?.bannerBackgroundColor
          : COLORS.PRIMARY_WHITE,
      }}
      className={translaterOpen ? classes.appSpacedBar : classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        {password === true ? (
          <>
            <LogoContainer
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-start"
                    : "flex-end",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogo
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                />
              ) : null}
            </LogoContainer>
            <ImageContainer>
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                <H2
                  style={{
                    color: globalState?.theme?.themeHeader?.eventTitleColor,
                    textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                  }}
                >
                  {globalState?.eventTitle}
                </H2>
              )}
            </ImageContainer>
          </>
        ) : (
          <>
            <LogoContainer
              justifyContent={globalState?.theme?.themeHeader?.logoPlacement}
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-end"
                    : "flex-start",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogo
                  onClick={() =>
                    LandingPage
                      ? scroller.scrollTo("hero", {
                          duration: 500,
                          offset: -70,
                          smooth: true,
                        })
                      : _.isEmpty(userObject)
                      ? ""
                      : navigate("/live")
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                />
              ) : null}
            </LogoContainer>
            <ImageContainer>
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                <H2
                  style={{
                    color: globalState?.theme?.themeHeader?.eventTitleColor,
                    textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                  }}
                >
                  {globalState?.eventTitle}
                </H2>
              )}
            </ImageContainer>
          </>
        )}

        <BigScreen>
          {hideLinks ? null : (
            <LinksContainer>
              {_.isEmpty(userObject) ||
              EXCLUDE_URL.some((path) => location?.pathname?.includes(path)) ? (
                <>
                  {NavPages ? (
                    <>
                      {globalState?.theme?.themeNavigationBar
                        ?.navBarTreatment === "alwaysVisible" &&
                      globalState?.customTab !== null ? (
                        globalState?.customTab[0]?.tabUrl.length ? (
                          <H2>
                            <DropDownMenu
                              title="Tabs"
                              options={globalState?.customTab
                                ?.filter(
                                  (tab) =>
                                    tab?.tabVisibility === "beforeLogin" ||
                                    tab?.tabVisibility === "both",
                                )
                                .map((item) => ({
                                  name: item?.tabTitle,
                                  link: item?.tabUrl,
                                }))}
                            />
                          </H2>
                        ) : null
                      ) : null}
                      {globalState?.theme?.themeNavigationBar
                        ?.navBarTreatment === "burgerMenu" && (
                        <H2>
                          <DropDownMenu
                            color={
                              globalState?.theme?.themeNavigationBar
                                ?.menuButtonTextColor
                            }
                            hoverColor={
                              globalState?.theme?.themeNavigationBar
                                ?.menuButtonHoverColor
                            }
                            menuBackgroundColor={
                              globalState?.theme?.themeNavigationBar
                                ?.menuButtonBgColor
                            }
                            activeMenuButtonBgColor={
                              globalState?.theme?.themeNavigationBar
                                ?.activeMenuButtonBgColor
                            }
                            activeMenuButtonTextColor={
                              globalState?.theme?.themeNavigationBar
                                ?.activeMenuButtonTextColor
                            }
                            options={[
                              ...before_login_inputs,
                              ...(globalState?.customTab !== null &&
                              globalState?.customTab[0]?.tabUrl.length
                                ? globalState?.customTab
                                    ?.filter(
                                      (tab) =>
                                        tab?.tabVisibility === "beforeLogin" ||
                                        tab?.tabVisibility === "both",
                                    )
                                    .map((item) => ({
                                      name: item?.tabTitle,
                                      link: item?.tabUrl,
                                    }))
                                : []),
                            ]}
                          />
                        </H2>
                      )}{" "}
                    </>
                  ) : (
                    <>
                      {globalState?.theme?.themeNavigationBar
                        ?.navBarTreatment === "alwaysVisible" &&
                      globalState?.customTab !== null ? (
                        globalState?.customTab[0]?.tabUrl.length ? (
                          <DropDownMenu
                            title="Tabs"
                            options={globalState?.customTab
                              ?.filter(
                                (tab) =>
                                  tab?.tabVisibility === "beforeLogin" ||
                                  tab?.tabVisibility === "both",
                              )
                              .map((item) => ({
                                name: item?.tabTitle,
                                link: item?.tabUrl,
                              }))}
                          />
                        ) : null
                      ) : null}
                      {globalState?.theme?.themeNavigationBar
                        ?.navBarTreatment === "burgerMenu" && (
                        <H2>
                          <DropDownMenu
                            color={
                              globalState?.theme?.themeNavigationBar
                                ?.menuButtonTextColor
                            }
                            hoverColor={
                              globalState?.theme?.themeNavigationBar
                                ?.menuButtonHoverColor
                            }
                            menuBackgroundColor={
                              globalState?.theme?.themeNavigationBar
                                ?.menuButtonBgColor
                            }
                            activeMenuButtonBgColor={
                              globalState?.theme?.themeNavigationBar
                                ?.activeMenuButtonBgColor
                            }
                            activeMenuButtonTextColor={
                              globalState?.theme?.themeNavigationBar
                                ?.activeMenuButtonTextColor
                            }
                            options={[
                              ...before_login_inputs,
                              ...(globalState?.customTab !== null &&
                              globalState?.customTab[0]?.tabUrl.length
                                ? globalState?.customTab
                                    ?.filter(
                                      (tab) =>
                                        tab?.tabVisibility === "beforeLogin" ||
                                        tab?.tabVisibility === "both",
                                    )
                                    .map((item) => ({
                                      name: item?.tabTitle,
                                      link: item?.tabUrl,
                                    }))
                                : []),
                            ]}
                          />
                        </H2>
                      )}{" "}
                    </>
                  )}
                </>
              ) : (
                <>
                  {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                    "alwaysVisible" && globalState?.customTab !== null ? (
                    globalState?.customTab[0]?.tabUrl?.length ? (
                      <H2>
                        <DropDownMenu
                          title="Tabs"
                          options={[
                            ...globalState?.customTab
                              ?.filter(
                                (tab) =>
                                  tab?.tabVisibility === "afterLogin" ||
                                  tab?.tabVisibility === "both",
                              )
                              .map((item) => ({
                                name: item?.tabTitle,
                                link: item?.tabUrl,
                              })),
                            {
                              name: "Sign Out",
                              props: {
                                onClick: () => handleLogout(),
                              },
                            },
                          ]}
                        />
                      </H2>
                    ) : (
                      <H2>
                        <DropDownMenu
                          title="Tabs"
                          options={[
                            {
                              name: "Sign Out",
                              props: {
                                onClick: () => handleLogout(),
                              },
                            },
                          ]}
                        />
                      </H2>
                    )
                  ) : (
                    globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                      "alwaysVisible" &&
                    globalState?.customTab === null && (
                      <H2>
                        <DropDownMenu
                          title="Tabs"
                          options={[
                            {
                              name: "Sign Out",
                              props: {
                                onClick: () => handleLogout(),
                              },
                            },
                          ]}
                        />
                      </H2>
                    )
                  )}
                  {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                    "burgerMenu" && (
                    <H2>
                      <DropDownMenu
                        color={
                          globalState?.theme?.themeNavigationBar
                            ?.menuButtonTextColor
                        }
                        hoverColor={
                          globalState?.theme?.themeNavigationBar
                            ?.menuButtonHoverColor
                        }
                        menuBackgroundColor={
                          globalState?.theme?.themeNavigationBar
                            ?.menuButtonBgColor
                        }
                        activeMenuButtonBgColor={
                          globalState?.theme?.themeNavigationBar
                            ?.activeMenuButtonBgColor
                        }
                        activeMenuButtonTextColor={
                          globalState?.theme?.themeNavigationBar
                            ?.activeMenuButtonTextColor
                        }
                        options={[
                          ...after_login_inputs,
                          ...(globalState?.customTab !== null &&
                          globalState?.customTab[0]?.tabUrl.length
                            ? globalState?.customTab
                                ?.filter(
                                  (tab) =>
                                    tab?.tabVisibility === "beforeLogin" ||
                                    tab?.tabVisibility === "both",
                                )
                                .map((item) => ({
                                  name: item?.tabTitle,
                                  link: item?.tabUrl,
                                }))
                            : []),
                          ...[
                            {
                              name: "Sign Out",
                              props: {
                                onClick: () => handleLogout(),
                              },
                            },
                          ],
                        ]}
                      />
                    </H2>
                  )}{" "}
                </>
              )}
            </LinksContainer>
          )}
        </BigScreen>

        <SmallScreenMenu>
          {_.isEmpty(userObject) ? (
            <>
              {" "}
              {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                "alwaysVisible" && globalState?.customTab !== null ? (
                globalState?.customTab[0]?.tabUrl.length ? (
                  <TemporaryDrawer
                    menuItems={globalState?.customTab
                      ?.filter(
                        (tab) =>
                          tab?.tabVisibility === "beforeLogin" ||
                          tab?.tabVisibility === "both",
                      )
                      .map((item) => ({
                        name: item?.tabTitle,
                        link: item?.tabUrl,
                      }))}
                  />
                ) : null
              ) : null}{" "}
              {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                "burgerMenu" && (
                <H2>
                  <DropDownMenu
                    color={
                      globalState?.theme?.themeNavigationBar
                        ?.menuButtonTextColor
                    }
                    hoverColor={
                      globalState?.theme?.themeNavigationBar
                        ?.menuButtonHoverColor
                    }
                    menuBackgroundColor={
                      globalState?.theme?.themeNavigationBar?.menuButtonBgColor
                    }
                    activeMenuButtonBgColor={
                      globalState?.theme?.themeNavigationBar
                        ?.activeMenuButtonBgColor
                    }
                    activeMenuButtonTextColor={
                      globalState?.theme?.themeNavigationBar
                        ?.activeMenuButtonTextColor
                    }
                    options={[
                      ...before_login_inputs,
                      ...(globalState?.customTab !== null &&
                      globalState?.customTab[0]?.tabUrl.length
                        ? globalState?.customTab
                            ?.filter(
                              (tab) =>
                                tab?.tabVisibility === "beforeLogin" ||
                                tab?.tabVisibility === "both",
                            )
                            .map((item) => ({
                              name: item?.tabTitle,
                              link: item?.tabUrl,
                            }))
                        : []),
                    ]}
                  />
                </H2>
              )}{" "}
            </>
          ) : null}
        </SmallScreenMenu>
        <SmallScreenMenu>
          {!_.isEmpty(userObject) ? (
            <>
              {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                "alwaysVisible" && globalState?.customTab !== null ? (
                globalState?.customTab[0]?.tabUrl.length ? (
                  <TemporaryDrawer
                    menuItems={[
                      ...globalState?.customTab
                        ?.filter(
                          (tab) =>
                            tab?.tabVisibility === "afterLogin" ||
                            tab?.tabVisibility === "both",
                        )
                        .map((item) => ({
                          name: item?.tabTitle,
                          link: item?.tabUrl,
                        })),
                      {
                        name: "Sign Out",
                        props: {
                          onClick: () => handleLogout(),
                        },
                      },
                    ]}
                  />
                ) : (
                  <TemporaryDrawer
                    menuItems={[
                      {
                        name: "Sign Out",
                        props: {
                          onClick: () => handleLogout(),
                        },
                      },
                    ]}
                  />
                )
              ) : null}{" "}
              {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                "alwaysVisible" &&
                globalState?.customTab === null && (
                  <H2>
                    <DropDownMenu
                      title="Tabs"
                      options={[
                        {
                          name: "Sign Out",
                          props: {
                            onClick: () => handleLogout(),
                          },
                        },
                      ]}
                    />
                  </H2>
                )}
              {globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                "burgerMenu" && (
                <H2>
                  <DropDownMenu
                    color={
                      globalState?.theme?.themeNavigationBar
                        ?.menuButtonTextColor
                    }
                    hoverColor={
                      globalState?.theme?.themeNavigationBar
                        ?.menuButtonHoverColor
                    }
                    menuBackgroundColor={
                      globalState?.theme?.themeNavigationBar?.menuButtonBgColor
                    }
                    activeMenuButtonBgColor={
                      globalState?.theme?.themeNavigationBar
                        ?.activeMenuButtonBgColor
                    }
                    activeMenuButtonTextColor={
                      globalState?.theme?.themeNavigationBar
                        ?.activeMenuButtonTextColor
                    }
                    options={[
                      ...after_login_inputs,
                      ...(globalState?.customTab !== null &&
                      globalState?.customTab[0]?.tabUrl.length
                        ? globalState?.customTab
                            ?.filter(
                              (tab) =>
                                tab?.tabVisibility === "beforeLogin" ||
                                tab?.tabVisibility === "both",
                            )
                            .map((item) => ({
                              name: item?.tabTitle,
                              link: item?.tabUrl,
                            }))
                        : []),
                      ...[
                        {
                          name: "Sign Out",
                          props: {
                            onClick: () => handleLogout(),
                          },
                        },
                      ],
                    ]}
                  />
                </H2>
              )}{" "}
            </>
          ) : (
            <SmallScreen>
              <Row>
                <LogoutText onClick={handleLogout}>
                  {labels["appbar.logout"]}
                </LogoutText>
                {password === true ? (
                  <ProfileImage
                    src={
                      userObject.avatarUrl
                        ? userObject.avatarUrl
                        : require("../../../assets/images/userPlaceholder.svg")
                    }
                    onClick={() => navigate("/live")}
                  />
                ) : null}
              </Row>
            </SmallScreen>
          )}
        </SmallScreenMenu>

        {/* {!_.isEmpty(userObject) ? (
          <MobileScreen>
            <Row>
              <Button
                onClick={() => {
                  setModal(!modal);
                }}
              >
                {modal ? <CloseIcon /> : <MenuIcon />}
              </Button>
            </Row>
            <Drawer
              anchor={"top"}
              open={modal}
              onClose={() => setModal(false)}
              style={{ zIndex: "1" }}
            >
              {password === true ? null : (
                <MenuModel
                  {...{
                    modal,
                    setModal,
                    NavPages,
                    hideLinks,
                    LandingPage,
                    cartCount,
                    userObject,
                    EXCLUDE_URL,
                    handleLogout,
                    stats,
                  }}
                />
              )}
            </Drawer>
          </MobileScreen>
        ) : null} */}
      </Toolbar>
    </AppBar>
  );
}
